import { Components, Theme, chipClasses as MuiChipClasses } from '@mui/material';

export const CHIP_SMALL_HEIGHT = '20px';

export const MuiChip: Components<Theme>['MuiChip'] = {
  defaultProps: {
    variant: 'filled',
    size: 'small',
  },
  styleOverrides: {
    root: {
      borderRadius: '4px',
    },
    sizeSmall: {
      height: CHIP_SMALL_HEIGHT,
    },
    deleteIcon: ({ theme }) => ({
      padding: '2px',
      color: theme.palette.text.secondary,
    }),
    icon: ({ theme }) => ({
      color: theme.palette.text.primary,
      width: '12px',
      height: '12px',
    }),
    iconSmall: ({ theme }) => ({
      marginLeft: theme.spacing(1),
    }),
    labelSmall: {
      fontSize: '12px',
    },
    // Represents default static chips and selected chips
    filled: ({ theme }) => {
      const darkModeBackgroundColor =
        theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.status.default.lowContrast;

      return {
        backgroundColor: darkModeBackgroundColor,
        border: `1px solid ${darkModeBackgroundColor}`,
        color: theme.palette.text.primary,
        [`& .${MuiChipClasses.icon}`]: {
          color: theme.palette.text.primary,
        },
      };
    },
    // Represents chips that are selectable but are not currently selected
    outlined: ({ theme }) => ({
      backgroundColor: theme.palette.background.container,
      border: `1px solid ${theme.palette.border.subtle}`,
      color: theme.palette.text.secondary,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.background.hover,
      },
      [`& .${MuiChipClasses.icon}`]: {
        color: theme.palette.text.secondary,
      },
    }),
  },
};
